<script>
  import {months, weekDays, getMonthData} from "./calendar";
  import { fade } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  const close = () => dispatch('close');
  const apply = () => dispatch('apply', {date:makeIsoDate(), epoch:makeEpoch()});

  const makeIsoDate = () =>
    `${dayYear}-${('0' + dayMonth).slice(-2)}-${('0' + day).slice(-2)}`
    +`T${('0' + (timeType === 'PM' ? hour + 12 : hour)).slice(-2)}:${('0' + min).slice(-2)}:00`

  const makeEpoch = () => new Date(makeIsoDate()).getTime();

  const setDay = (calendarDay) => {day = calendarDay; dayMonth=month; dayYear=year;}


  export let time;

  let initialDate = time? new Date(time) : new Date();

  let year = initialDate.getFullYear();
  let month = initialDate.getMonth()+1;

  let day = time ? initialDate.getDate() : undefined;
  let dayMonth = time ? initialDate.getMonth()+1 : undefined;
  let dayYear = time ? initialDate.getFullYear() : undefined;

  let hour = time ? initialDate.getHours() : 0;
  let min = time ? initialDate.getMinutes() : 0;

  let timeType = '24'
  let prevType = timeType
  let prevHr = hour
  let minutes = [...Array(60).keys()]
  let hours24 = [...Array(24).keys()]
  let hours12 = [...Array(12).keys()].map(i => i+1)
  $: hours = timeType === '24' ? hours24 : hours12

  function setNow() {
    let now = new Date()
    dayMonth = now.getMonth() + 1;
    dayYear = now.getFullYear();
    month = dayMonth;
    year = dayYear;
    if (timeType === '24') {
      hour = now.getHours();
    } else {
      if (now.getHours() > 12) {
        hour = now.getHours() - 12;
        timeType = 'PM'
      } else {
        hour = now.getHours();
        timeType = 'AM'
      }
    }
    min = now.getMinutes();

    day = now.getDate();
  }

  function nextMonth() {
    year = month === 12 ? year + 1 : year
    month = month === 12 ? 1 : month + 1
  }

  function prevMonth() {
    year = month === 1 ? year - 1 : year;
    month = month === 1 ? 12 : month - 1
  }

  $: rows = getMonthData(year, month)
  $: {
    if (timeType !== '24') {
      if (hour > 12) {
        hour = hour - 12
      }
    } else if (prevType === 'PM') {
      hour = hour + 12
    }
    prevType = timeType
    prevHr = hour
  }
</script>

<div class="calendar" transition:fade={{duration:80}}>
    <div class="month-year">
        <div on:click={prevMonth} class="month-button"> &lt; </div>
        {months[month-1]}, {year}
        <div on:click={nextMonth} class="month-button"> &gt; </div>
    </div>

    <table>
        <tr>
            {#each weekDays as weekDay}
                <th>{weekDay}</th>
            {/each}
        </tr>
        {#each rows as row}
            <tr>
                {#each row as calendarDay}
                    <td on:click={()=>setDay(calendarDay)}
                        class:current={calendarDay == day
					&& dayMonth == month
					&& dayYear == year}>{calendarDay}</td>
                {/each}
            </tr>
        {/each}
    </table>

    <div class="hour-selector">
        <select bind:value={hour}>
            {#each hours as hour}
                <option value={hour}>{`${('0' + hour).slice(-2)}`}</option>
            {/each}
        </select>
        <select bind:value={min}>
            {#each minutes as minute}
                <option value={minute}>{`${('0' + minute).slice(-2)}`}</option>
            {/each}
        </select>
        <select bind:value={timeType}>
            <option value="AM">AM</option>
            <option value="PM">PM</option>
            <option value="24">24h</option>
        </select>
    </div>

    <div class="bottom-buttons">
        <button on:click={apply} disabled={!day}>
            Apply
        </button>
        <span class="button" on:click={setNow}>Set Today / Now</span>
        <span class="button blue" on:click={close}>Cancel</span>
    </div>
</div>

<style>
    .calendar {
        user-select: none;
        padding: 10px;
        border-radius: 5px;
        box-shadow: 0px 0px 5px;
        display: inline-flex;
        flex-direction: column;
        background-color: white;
    }

    .calendar tr td {
        min-width: 35px;
        text-align: right;
        cursor: pointer;
        padding-top: 4px;
    }

    .month-year {
        font-size: 1.4em;
        padding-bottom: 10px;

        display:flex;
        justify-content: space-between;
        align-items: center;
    }

    th {
        background-color: #efefef;
        font-weight: normal;
        padding: 4px;
    }

    .month-button {
        border-radius: 10px;
        background-color: #efefef;
        padding: 10px;
        display: inline-block;
    }

    button {
        margin:0
    }

    select {
        margin:0;
        border-radius: 10px;
    }

    .button {
        cursor: pointer;
    }

    .blue {
        color:navy;
    }

    .current {
        font-weight: bold;
        background-color: #efefef;
    }

    .hour-selector {
        margin: 5px;
        display: flex;
        justify-content: center;
        align-items:center;
    }
    .bottom-buttons {
        display: flex;
        justify-content:
                space-between;
        align-items:center
    }
</style>
